<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-card header="基本设置">
                <!-- <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8"> -->
                <el-form-item prop="name" label="专题名称:">
                    <el-input v-model.trim="formData.name" maxlength="20" placeholder="建议15个汉字以内"></el-input>
                </el-form-item>
                <!-- </el-col>
                </el-row> -->
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="headPhoto" label="主题头图:" :rules='[{ required: true, message: "请上传专题头图" }]'>
                            <image-upload :width="750" :height="460" :url.sync="formData.headPhoto" :urlFull.sync="formData.headPhoto"
                                ref="posterUpload" class="poster-upload" @onSuccess="handleImageSuccess1">
                            </image-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="background" label="主题背景:" :rules='[{ required: true, message: "请上传背景图" }]'>
                            <image-upload :width="750" :height="1624" :url.sync="formData.background" :urlFull.sync="formData.background"
                                ref="posterUpload" class="poster-upload" @onSuccess="handleImageSuccess2">
                            </image-upload>
                        </el-form-item>
                    </el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="defaultCity" label="默认城市:" :rules='[{ required: true, message: "请选择默认城市" }]'>
							<el-radio-group
								v-model="formData.defaultCity"
								size="medium"
							>
								<el-radio :label="0">全部</el-radio>
								<el-radio :label="1">当前有演出城市</el-radio>
								<!-- 不可选择城市：H5专题页不展示城市选择，直接展示全部演出 -->
								<el-radio :label="2">不可选择城市</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
                </el-row>
            </el-card>
            <el-card class="MT20">
                <div slot="header">其他活动：<small class="color-info">支持运营专题活动、分享活动、膨胀红包</small></div>
                <div class="card-content">
                    <div class="search-bar">
                        <el-input placeholder="输入活动ID" class="input-with-select" v-model="searchParams.value">
                            <el-select v-model="searchParams.type" slot="prepend" placeholder="请选择">
                                <el-option label="膨胀红包" :value="1"></el-option>
                                <el-option label="运营专题" :value="2"></el-option>
                                <el-option label="分享活动" :value="3"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加活动</el-button>
                        </el-input>
                    </div>
                    <el-table :data="formData.eventList" border style="width: 100%" size="small" row-key="id" stripe
                        class="MT10 sortable-table">
                        <el-table-column label="排序" width="48" class-name="sort-handle">
                            <span class="el-icon-sort"></span>
                        </el-table-column>
                        <el-table-column prop="id" label="活动ID"></el-table-column>
                        <el-table-column label="活动类型">
                            <template slot-scope="{row} = scope">
                                <span v-if="row.type == 1">膨胀红包</span>
                                <span v-if="row.type == 2">运营专题</span>
                                <span v-if="row.type == 3">分享活动</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="活动名称" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed="right" label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="handleDelete(scope.$index)">解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
            <div class="MT30">
                <el-button @click="goBack">返回</el-button>
                <el-button v-if="$utils.have('/operational/theme/bindActivity')" type="primary" @click="onSubmit"
                    :loading="btnLoading">下一步</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import Sortable from "sortablejs";
const defaultFormData = {
    name: "",
    headPhoto: "",
    background: "",
    eventList: []
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    components: { ImageUpload },
    data() {
        return {
            dataLoading: false,
            formData: {
                ...defaultFormData
            },
            btnLoading: false,
            redirect: this.$route.query.redirect,
            rules: {
                name: [{ required: true, message: "请输入名称" }],
                headPhoto: [{ required: true, message: "请上传专题头图" }],
                background: [{ required: true, message: "请上传背景图" }]
            },
            searchParams: {
                type: 1,
                value: ""
            }
        }
    },
    mounted() {
        if (this.id) {
            this.getDataDetail();
        }else{
            this.formData.eventList = []
        }
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.push({
                    path: '/operation/special/list',
                });
            }
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/operational/theme/detail",
                params: { id: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...this.defaultFormData,
                            ...result,
                            eventList: result?.eventList ? [...result.eventList] : []
                        }
                        this.drag();
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        handleImageSuccess1() {
            if (this.formData.headPhoto) {
                this.$refs["formData"].clearValidate('headPhoto');
            }
        },
        handleImageSuccess2() {
            if (this.formData.background) {
                this.$refs["formData"].clearValidate('background');
            }
        },
        //拖拽排序
        drag() {
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                Sortable.create(el, {
                    disabled: false, // 拖拽不可用? false 启用
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    handle: ".sort-handle",
                    onEnd: (e) => { // 拖拽结束时的触发
                        let arr = JSON.parse(JSON.stringify(this.formData.eventList)); // 获取表数据
                        arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                        this.$nextTick(() => {
                            this.formData.eventList = [...arr];
                        })
                    },
                });
            })
        },
        //解绑活动
        handleDelete(index) {
            this.formData.eventList.splice(index, 1);
        },
        //搜索活动
        searchActivity() {
            if (!this.searchParams.value) return;
            this.$request({
                url: "/common/queryEvent",
                method: "POST",
                params: {
                    type: this.searchParams.type,
                    id: this.searchParams.value
                },
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        const _list = this.formData.eventList.filter(v => (v.type == result.type && v.id == result.id) )
                        if ( _list.length < 1 ) {
                            this.formData.eventList.push(result)
                        }
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/operational/theme/saveTheme",
                        method: "POST",
                        data: {
                            ...this.formData
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg, result } = res.data;
                            if (state && result) {
                                this.$router.push({
                                    path: `/operation/special/edit/step2/${result}`,
                                    query: {
                                        redirect: this.redirect,
                                    },
                                })
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped></style>